"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTP_STATUSES = void 0;
var HTTP_STATUSES;
(function (HTTP_STATUSES) {
    HTTP_STATUSES[HTTP_STATUSES["Unauthorized"] = 403] = "Unauthorized";
})(HTTP_STATUSES = exports.HTTP_STATUSES || (exports.HTTP_STATUSES = {}));
//# sourceMappingURL=Constants.js.map